import React, { Component } from "react";
import classnames from "classnames";

import styles from "./ModalEmaillingContent.local.scss";

export default class ModalEmaillingFetching extends Component {
  render() {
    let items = [];
    for (let i = 0; i < 3; i++) {
      items.push(
        <div className={styles.container} key={i}>
          <div className={styles.gradiant} />
          <div className={styles.gradiant} />
          <div className={styles.modal_info}>
            <div className={classnames(styles.icone, styles.gradiant)} />
            <div className={styles.gradiant} />
          </div>
          <div className={styles.modal_info}>
            <div className={classnames(styles.icone, styles.gradiant)} />
            <div className={styles.gradiant} />
          </div>
          <div className={styles.modal_info}>
            <div className={classnames(styles.icone, styles.gradiant)} />
            <div className={styles.gradiant} />
          </div>
          <div
            className={classnames(styles.modal_description, styles.gradiant)}
          />
          <div className={classnames(styles.button, styles.gradiant)} />
        </div>
      );
    }
    return (
      <div className={`small-12 columns ${styles.modals_fetching}`}>
        <div className={styles.details}>
          <div>
            <div className={styles.gradiant} />
            <div className={styles.gradiant} />
          </div>
          <div>
            <div className={styles.gradiant} />
            <div className={styles.gradiant} />
          </div>
        </div>
        <hr />
        <div className={styles.frames}>{items}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FicheClient/ModalEmaillingFetching.js